import React, {useCallback, useState, useEffect} from 'react';
import {DataGrid, GridOverlay, GridToolbarContainer} from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import FromFieldDate from '../../../atoms/FromFieldDate';
import "react-datepicker/dist/react-datepicker.css";
import {getFarDepreciation, getFarDepreciationCSV} from '../../../services/asset.service';
import {Parser} from "json2csv";
import {Box, Pagination} from '@mui/material';
import * as CryptoJS from "crypto-js";
import Select from "react-select";
import '../AssetInfo/AssetList.css';
import '../AssetInfo/DataGridStyles.css';

/* ─── Date Helpers (unchanged) ─── */
Date.prototype.dbFormatedDate = function () {
    let year = this.getFullYear();
    let month = this.getMonth() + 1;
    let day = this.getDate();
    if (month < 10) month = '0' + month;
    if (day < 10) day = '0' + day;
    return year + '-' + month + '-' + day;
}

function getFormatedDate(dateString) {
    if (dateString !== null) {
        let dte = new Date(dateString);
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) month = '0' + month;
        if (day < 10) day = '0' + day;
        return year + '-' + month + '-' + day;
    } else {
        return null;
    }
}

function FarDepreciation() {
    /* ─── All State (unchanged) ─── */
    const [items, setItems] = useState([]);
    const [itemsCSV, setItemsCSV] = useState([]);
    const [loading, setLoading] = useState(false);
    const [exporting, setExporting] = useState(false);
    const [page, setPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [pageSize, setPageSize] = useState(50);
    const [fromperiod, setFromPeriod] = useState('');
    const [ErrFromPeriod, setErrFromPeriod] = useState('');
    const [toperiod, setToPeriod] = useState('');
    const [ErrToPeriod, setErrToPeriod] = useState('');

    const calculateOffset = (page, pageSize) => (page - 1) * pageSize;

    /* ─── All Handlers (unchanged logic) ─── */
    const fetchDepreciation = useCallback(async () => {
        if (fromperiod !== '' && fromperiod !== null) {
            setErrFromPeriod('');
        } else {
            setErrFromPeriod('Please select From Date');
            return false;
        }
        if (toperiod !== null && toperiod !== '') {
            setErrToPeriod('');
        } else {
            setErrToPeriod('Please select To Date');
            return false;
        }
        setLoading(true);
        const offset = calculateOffset(page, pageSize);
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify({
            param_data: {
                'from_date': getFormatedDate(fromperiod),
                'to_date': getFormatedDate(toperiod),
                'offset': offset, 'pageSize': pageSize
            },
            authToken: sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();

        try {
            const res = await getFarDepreciation({token: encryptedData});
            if (res?.data?.data?.assetDeprisiation.length) {
                setItems(res.data.data.assetDeprisiation);
                setTotalItems(res.data.data.total || 0);
            } else {
                setItems('');
            }
        } catch (error) {
            console.error('Error fetching assets:', error);
        } finally {
            setLoading(false);
        }
    }, [fromperiod, toperiod, page, pageSize]);

    const fetchAssetsCSV = useCallback(async () => {
        if (fromperiod !== '' && fromperiod !== null) {
            setErrFromPeriod('');
        } else {
            setErrFromPeriod('Please select From Date');
            return false;
        }
        if (toperiod !== null && toperiod !== '') {
            setErrToPeriod('');
        } else {
            setErrToPeriod('Please select To Date');
            return false;
        }
        setExporting(true);
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify({
            param_data: {
                'from_date': getFormatedDate(fromperiod),
                'to_date': getFormatedDate(toperiod),
                'offset': '', 'pageSize': ''
            },
            authToken: sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();

        try {
            const resCSV = await getFarDepreciationCSV({token: encryptedData});
            if (resCSV?.data?.data?.length) {
                setItemsCSV(resCSV.data.data);
            }
        } catch (error) {
            console.error('Error fetching assets CSV:', error);
        } finally {
            setExporting(false);
        }
    }, [fromperiod, toperiod]);

    useEffect(() => {
        if (itemsCSV.length > 0) {
            generateCSV();
        }
    }, [itemsCSV]);

    const handlePageSizeChange = (value) => {
        setPageSize(value);
        setPage(1);
    };

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const totalPages = Math.ceil(totalItems / pageSize);

    const handleExportToCSV = async () => {
        await fetchAssetsCSV();
    };

    const generateCSV = () => {
        try {
            const jsonData = itemsCSV.map(item => ({
                "TAG": item.tag || '', "Parent Tag": item.parent_tag || '',
                "Year of Addition": item.year_of_addition || '', "Type of Addition": item.type_of_addition || '',
                "Project Marking": item.project_marking || '', "PO No (If Any)": item.po_no || '',
                "Supplier Code (if Any)": item.supplier_code || '', "Name of the Supplier": item.supplier_name || '',
                "Invoice No": item.invoice_no || '', "Invoice Date": item.invoice_date ? getFormatedDate(item.invoice_date) : '',
                "Bill of Entry No": item.boe_no || '', "Date of BOE": item.boe_date ? getFormatedDate(item.boe_date) : '',
                "Shipping / AWB No": item.shipping_awb_no || '', "Date of Shipping/AWB": item.shipping_awb_date ? getFormatedDate(item.shipping_awb_date) : '',
                "Accounting Voucher No": item.accounting_voucher_no || '', "Internal Approval No": item.internal_approval_no || '',
                "Cost Center Code": item.cost_center_code || '', "Cost Center Name": item.cost_center_name || '',
                "Invoice Currency": item.invoice_currency || '', "Basic Cost p.u in Fx": item.invoice_value_fx || '',
                "Basic Cost p.u in INR": item.invoice_value_inr || '', "Forwarding & Insurance": item.forwarding_and_insurance || '',
                "Installation": item.installation || '', "Errection": item.errection || '',
                "Total Cost Without Tax p.u": item.total_cost_without_tax || '', "Customs": item.customs || '',
                "CGST": item.cgst || '', "SGST": item.sgst || '', "IGST": item.igst || '',
                "Other Taxes": item.other_taxes || '', "Total Tax p.u": item.total_tax || '',
                "Total Cost with Tax p.u": item.value_of_asset || '', "Qty": item.qty || '',
                "Unit Of Measure": item.unit_of_measure || '', "Name of the Asset (as per Invoice)": item.tag_name || '',
                "Detailed Description of the Asset": item.asset_description || '', "Nature of Presence": item.nature_of_presence || '',
                "Nature of Addition": item.nature_of_addition || '', "Principal Asset to which Cost is Added": item.principal_asset_tag || '',
                "Unique Sl No of the Asset": item.asset_serial_no || '', "Make / Manufacturer": item.manufacturer || '',
                "Model No": item.model_no || '', "Part No": item.part_no || '',
                "Control Department": item.department_name || '', "comp ref no": item.comp_ref_no || '',
                "Asset TAG Name": item.tag_name || '', "Asset TAG Branch": item.tag_division || '',
                "Security Seal Date": item.security_seal_date ? getFormatedDate(item.security_seal_date) : '',
                "Class of Asset": item.class_of_asset || '', "Record Start Date": item.record_start_date ? getFormatedDate(item.record_start_date) : '',
                "Parent TAG": item.parent_tag || '', "Depreciation mode": item.cap_type_of_asset || '',
                "Date of Capitalization / Asset Ready To Use": item.asset_in_use_date ? getFormatedDate(item.asset_in_use_date) : '',
                "Type of Depreciation": item.type_of_depreciation || '', "Depreciation Rate(No. of years) [I-GAAP]": item.depreciation_rate || '',
                "End Date [I-GAAP]": item.depreciation_end_date ? getFormatedDate(item.depreciation_end_date) : '',
                "Accounting Code of Asset": item.accounting_code || '', "Accounting Name of the Asset": item.accounting_name || '',
                "Financials Classification": item.category_name || '', "Put to Use Date": item.put_to_use_date ? getFormatedDate(item.put_to_use_date) : '',
                "Final Asset Capitalization Flag": item.final_asset || '', "Is Tax Capitalized": item.is_tax_capitalized || '',
                "Invoice Currency": item.invoice_currency || '', "Exchange Rate": item.exchange_rate || '',
                "Is 100% Depreciable Asset [I-GAAP]": item.is_100_perc_depreciable || '',
                "Pre Capitalized Asset Value": item.pre_capitalized_asset_value || '',
                "Is any other Accg GAAP Applicable": item.is_any_other_accg_gaap_applicable || '',
                "I-GAAP - Limit for 100% Depreciable Asset (Rs)": item.igaap_limit_amount || '',
                "Salvage Value": item.salvage_value || '', "Capitalized Value (I-GAAP)": item.igaap_capitalized_value || '',
                "other_record_start_date": item.other_record_start_date ? getFormatedDate(item.other_record_start_date) : '',
                "Is 100% Depreciable Asset [Other-GAAP]": item.is_100_perc_other_depreciable || '',
                "Depreciation Rate(No. of years) [Other-GAAP]": item.other_depreciation_rate || '',
                "End Date [Other-GAAP]": item.depreciation_other_end_date ? getFormatedDate(item.depreciation_other_end_date) : '',
                "Other-GAAP - Limit for 100% Depreciable Asset (Rs)": item.othergaap_limit_amount || '',
                "Capitalized Value (Other GAAP)": item.othergaap_capitalized_value || '',
                "Allocation Status": item.allocation_status || '', "Division": item.division || '',
                "Premises": item.premises || '', "Floor": item.floor || '', "Site ID": item.site_id || '',
                "Rack Id": item.rack_id || '', "User Type": item.user_type || '',
                "User Department": item.user_department || '', "Employee ID": item.employee_id || '',
                "Employee Name": item.employee_name || '', "User Mail ID": item.user_mail_id || '',
                "Alternative Verification": item.alternative_verification || '', "Child Allocation": item.child_allocation || '',
                "Effective Date": item.effective_date || '', "TAG ": item.tag || '',
                "Opening Value": item.asset_ob || '', "Addition": item.asset_added_value || '',
                "Deletion": item.asset_deleted_value || '', "Closing Value": item.asset_cb || '',
                "Opening Acc Dep": item.depreciation_ob || '', "Addition for the Period": item.depreciation_added_value || '',
                "Deletion for the Period": item.depreciation_deleted_value || '',
                "Adjustment for the Period": item.depreciation_adjusted_value || '',
                "Closing Acc Dep": item.new_depreciation_cb || '', "Opening WDV": item.wdv_ob || '',
                "Closing WDV": item.wdv_cb || '', "No. of days": item.no_of_day || '',
                "Created Date": item.created_at ? getFormatedDate(item.created_at) : '',
            }));

            const json2csvParser = new Parser();
            const csv = json2csvParser.parse(jsonData);
            const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'FAR_Depreciation.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error exporting data to CSV:', error);
        }
    };

    /* ─── Columns (backend unchanged - massive column list preserved) ─── */
    const columns = [
        {field: "id", hideable: true, hide: true, editable: false, headerName: "Sl No", width: 50},
        {field: "asset_name", hideable: true, hide: false, editable: false, headerName: "Asset Name", width: 250},
        {field: "asset_description", hideable: true, hide: false, editable: false, headerName: "Asset Description", width: 250},
        {field: "year_of_addition", hideable: true, hide: false, editable: false, headerName: "Year of Addition", width: 250},
        {field: "type_of_addition", hideable: true, hide: false, editable: false, headerName: "Type of Addition", width: 250},
        {field: "project_marking", hideable: true, hide: false, editable: false, headerName: "Project Marking", width: 250},
        {field: "po_no", hideable: true, hide: false, editable: false, headerName: "PO No (If Any)", width: 250},
        {field: "supplier_code", hideable: true, hide: false, editable: false, headerName: "Supplier Code (if Any)", width: 250},
        {field: "supplier_name", hideable: true, hide: false, editable: false, headerName: "Name of the Supplier", width: 250},
        {field: "invoice_no", hideable: true, hide: false, editable: false, headerName: "Invoice No", width: 250},
        {field: "invoice_date", hideable: true, hide: false, editable: false, headerName: "Invoice Date", width: 250, renderCell: (params) => <p>{getFormatedDate(params.row.invoice_date)}</p>},
        {field: "boe_no", hideable: true, hide: false, editable: false, headerName: "Bill of Entry No", width: 250},
        {field: "boe_date", hideable: true, hide: false, editable: false, headerName: "Date of BOE", width: 250, renderCell: (params) => <p>{getFormatedDate(params.row.boe_date)}</p>},
        {field: "shipping_awb_no", hideable: true, hide: false, editable: false, headerName: "Shipping / AWB No", width: 250},
        {field: "shipping_awb_date", hideable: true, hide: false, editable: false, headerName: "Date of Shipping/AWB", width: 250, renderCell: (params) => <p>{getFormatedDate(params.row.shipping_awb_date)}</p>},
        {field: "accounting_voucher_no", hideable: true, hide: false, editable: false, headerName: "Accounting Voucher No", width: 250},
        {field: "internal_approval_no", hideable: true, hide: false, editable: false, headerName: "Internal Approval No", width: 250},
        {field: "cost_center_code", hideable: true, hide: false, editable: false, headerName: "Cost Center Code", width: 250},
        {field: "cost_center_name", hideable: true, hide: false, editable: false, headerName: "Cost Center Name", width: 250},
        {field: "invoice_currency", hideable: true, hide: false, editable: false, headerName: "Invoice Currency", width: 250},
        {field: "exchange_rate", editable: false, hide: true, headerName: "Exchange Rate", width: 130, renderCell: (params) => <p>{parseFloat(params.row.exchange_rate).toFixed(2)}</p>},
        {field: "invoice_value_fx", editable: false, hide: true, headerName: "Basic Cost p.u in Fx", width: 180, renderCell: (params) => <p>{parseFloat(params.row.invoice_value_fx).toFixed(2)}</p>},
        {field: "invoice_value_inr", editable: false, hide: true, headerName: "Basic Cost p.u in INR", width: 180, renderCell: (params) => <p>{parseFloat(params.row.invoice_value_inr).toFixed(2)}</p>},
        {field: "forwarding_and_insurance", editable: false, hide: true, headerName: "Forwarding & Insurance", width: 180, renderCell: (params) => <p>{parseFloat(params.row.forwarding_and_insurance).toFixed(2)}</p>},
        {field: "installation", editable: false, hide: true, headerName: "Installation", width: 130, renderCell: (params) => <p>{parseFloat(params.row.installation).toFixed(2)}</p>},
        {field: "errection", editable: false, hide: true, headerName: "Erection", width: 130, renderCell: (params) => <p>{parseFloat(params.row.errection).toFixed(2)}</p>},
        {field: "customs", editable: false, hide: true, headerName: "Customs", width: 130, renderCell: (params) => <p>{parseFloat(params.row.customs).toFixed(2)}</p>},
        {field: "cgst", editable: false, hide: true, headerName: "CGST", width: 130, renderCell: (params) => <p>{parseFloat(params.row.cgst).toFixed(2)}</p>},
        {field: "sgst", editable: false, hide: true, headerName: "SGST", width: 130, renderCell: (params) => <p>{parseFloat(params.row.sgst).toFixed(2)}</p>},
        {field: "igst", editable: false, hide: true, headerName: "IGST", width: 130, renderCell: (params) => <p>{parseFloat(params.row.igst).toFixed(2)}</p>},
        {field: "other_taxes", editable: false, hide: true, headerName: "Other Taxes", width: 130, renderCell: (params) => <p>{parseFloat(params.row.other_taxes).toFixed(2)}</p>},
        {field: "total_tax", editable: false, hide: true, headerName: "Total Tax p.u", width: 130, renderCell: (params) => <p>{parseFloat(params.row.total_tax).toFixed(2)}</p>},
        {field: "value_of_asset", editable: false, hide: false, headerName: "Total cost with tax p.u", width: 200, renderCell: (params) => <p>{parseFloat(params.row.value_of_asset).toFixed(2)}</p>},
        {field: "qty", editable: false, hide: false, headerName: "Qty", width: 130, renderCell: (params) => <p>{parseFloat(params.row.qty).toFixed(2)}</p>},
        {field: "total_cost_without_tax", editable: false, hide: false, headerName: "Total Cost Without Tax p.u", width: 220, renderCell: (params) => <p>{parseFloat(params.row.total_cost_without_tax).toFixed(2)}</p>},
        {field: "tax", editable: false, hide: true, headerName: "Tax", width: 130, renderCell: (params) => <p>{parseFloat(params.row.tax).toFixed(2)}</p>},
        {field: "unit_of_measure", hideable: true, hide: false, editable: false, headerName: "Unit Of Measure", width: 250},
        {field: "nature_of_presence", hideable: true, hide: false, editable: false, headerName: "Nature of Presence", width: 250},
        {field: "nature_of_addition", hideable: true, hide: false, editable: false, headerName: "Nature of Addition", width: 250},
        {field: "principal_asset_tag", hideable: true, hide: false, editable: false, headerName: "Principal Asset to which Cost is Added", width: 250},
        {field: "asset_serial_no", hideable: true, hide: false, editable: false, headerName: "Unique Sl No of the Asset", width: 250},
        {field: "manufacturer", hideable: true, hide: false, editable: false, headerName: "Make / Manufacturer", width: 250},
        {field: "model_no", hideable: true, hide: false, editable: false, headerName: "Model No", width: 250},
        {field: "part_no", hideable: true, hide: false, editable: false, headerName: "Part No", width: 250},
        {field: "department_name", hideable: true, hide: false, editable: false, headerName: "Control Department", width: 250},
        {field: "comp_ref_no", hideable: true, hide: false, editable: false, headerName: "comp ref no", width: 250},
        {field: "tag_name", hideable: true, hide: false, editable: false, headerName: "Asset TAG Name", width: 250},
        {field: "tag_division", hideable: true, hide: false, editable: false, headerName: "Asset TAG Branch", width: 250},
        {field: "security_seal_date", hideable: true, hide: false, editable: false, headerName: "Security Seal Date", width: 250, renderCell: (params) => <p>{getFormatedDate(params.row.security_seal_date)}</p>},
        {field: "class_of_asset", hideable: true, hide: false, editable: false, headerName: "Class of Asset", width: 250},
        {field: "record_start_date", hideable: true, hide: false, editable: false, headerName: "Record Start Date", width: 250, renderCell: (params) => <p>{getFormatedDate(params.row.record_start_date)}</p>},
        {field: "parent_tag", hideable: true, hide: false, editable: false, headerName: "Parent TAG", width: 250},
        {field: "cap_type_of_asset", hideable: true, hide: false, editable: false, headerName: "Depreciation mode", width: 250},
        {field: "asset_in_use_date", hideable: true, hide: false, editable: false, headerName: "Date of Capitalization / Asset Ready To Use", width: 250, renderCell: (params) => <p>{getFormatedDate(params.row.asset_in_use_date)}</p>},
        {field: "type_of_depreciation", hideable: true, hide: false, editable: false, headerName: "Type of Depreciation", width: 250},
        {field: "depreciation_rate", hideable: true, hide: false, editable: false, headerName: "Depreciation Rate(No. of years) [I-GAAP]", width: 250, renderCell: (params) => <p>{parseFloat(params.row.depreciation_rate).toFixed(2)}</p>},
        {field: "depreciation_end_date", hideable: true, hide: false, editable: false, headerName: "End Date [I-GAAP]", width: 250, renderCell: (params) => <p>{getFormatedDate(params.row.depreciation_end_date)}</p>},
        {field: "accounting_code", hideable: true, hide: false, editable: false, headerName: "Accounting Code of Asset", width: 250},
        {field: "accounting_name", hideable: true, hide: false, editable: false, headerName: "Accounting Name of the Asset", width: 250},
        {field: "category_name", hideable: true, hide: false, editable: false, headerName: "Financials Classification", width: 250},
        {field: "put_to_use_date", hideable: true, hide: false, editable: false, headerName: "Put to Use Date", width: 250, renderCell: (params) => <p>{getFormatedDate(params.row.put_to_use_date)}</p>},
        {field: "final_asset", hideable: true, hide: false, editable: false, headerName: "Final Asset Capitalization Flag", width: 250},
        {field: "is_tax_capitalized", hideable: true, hide: false, editable: false, headerName: "Is Tax Capitalized", width: 250},
        {field: "is_100_perc_depreciable", hideable: true, hide: false, editable: false, headerName: "Is 100% Depreciable Asset [I-GAAP] ", width: 250},
        {field: "pre_capitalized_asset_value", hideable: true, hide: false, editable: false, headerName: "Pre Capitalized Asset Value", width: 250, renderCell: (params) => <p>{parseFloat(params.row.pre_capitalized_asset_value).toFixed(2)}</p>},
        {field: "is_any_other_accg_gaap_applicable", hideable: true, hide: false, editable: false, headerName: "Is any other Accg GAAP Applicable", width: 250},
        {field: "igaap_limit_amount", hideable: true, hide: false, editable: false, headerName: "I-GAAP - Limit for 100% Depreciable Asset (Rs)", width: 250, renderCell: (params) => <p>{parseFloat(params.row.igaap_limit_amount).toFixed(2)}</p>},
        {field: "salvage_value", hideable: true, hide: false, editable: false, headerName: "Salvage Value", width: 250, renderCell: (params) => <p>{parseFloat(params.row.salvage_value).toFixed(2)}</p>},
        {field: "igaap_capitalized_value", hideable: true, hide: false, editable: false, headerName: "Capitalized Value (I-GAAP)", width: 250, renderCell: (params) => <p>{parseFloat(params.row.igaap_capitalized_value).toFixed(2)}</p>},
        {field: "other_record_start_date", hideable: true, hide: false, editable: false, headerName: "Record Start Date [Other-GAAP] ", width: 250, renderCell: (params) => <p>{getFormatedDate(params.row.other_record_start_date)}</p>},
        {field: "is_100_perc_other_depreciable", hideable: true, hide: false, editable: false, headerName: "Is 100% Depreciable Asset [Other-GAAP]", width: 250},
        {field: "other_depreciation_rate", hideable: true, hide: false, editable: false, headerName: "Depreciation Rate(No. of years) [Other-GAAP] ", width: 250, renderCell: (params) => <p>{parseFloat(params.row.other_depreciation_rate).toFixed(2)}</p>},
        {field: "depreciation_other_end_date", hideable: true, hide: false, editable: false, headerName: "End Date [Other-GAAP]", width: 250, renderCell: (params) => <p>{getFormatedDate(params.row.depreciation_other_end_date)}</p>},
        {field: "othergaap_limit_amount", hideable: true, hide: false, editable: false, headerName: "Other-GAAP - Limit for 100% Depreciable Asset (Rs)", width: 250, renderCell: (params) => <p>{parseFloat(params.row.othergaap_limit_amount).toFixed(2)}</p>},
        {field: "othergaap_capitalized_value", hideable: true, hide: false, editable: false, headerName: "Capitalized Value (Other GAAP)", width: 250, renderCell: (params) => <p>{parseFloat(params.row.othergaap_capitalized_value).toFixed(2)}</p>},
        {field: "division", hideable: true, hide: false, editable: false, headerName: "Division", width: 150},
        {field: "premises", hideable: true, hide: false, editable: false, headerName: "Premises", width: 150},
        {field: "floor", hideable: true, hide: false, editable: false, headerName: "Floor", width: 150},
        {field: "site_id", hideable: true, hide: false, editable: false, headerName: "Site ID", width: 150},
        {field: "rack_id", hideable: true, hide: false, editable: false, headerName: "Rack Id", width: 150},
        {field: "user_type", hideable: true, hide: false, editable: false, headerName: "User Type", width: 150},
        {field: "user_department", hideable: true, hide: false, editable: false, headerName: "User Department", width: 150},
        {field: "employee_id", hideable: true, hide: false, editable: false, headerName: "Employee ID", width: 150},
        {field: "employee_name", hideable: true, hide: false, editable: false, headerName: "Employee Name", width: 150},
        {field: "user_mail_id", hideable: true, hide: false, editable: false, headerName: "User Mail ID", width: 150},
        {field: "alternative_verification", hideable: true, hide: false, editable: false, headerName: "Alternative Verification", width: 150},
        {field: "child_allocation", hideable: true, hide: false, editable: false, headerName: "Child Allocation ", width: 150},
        {field: "effective_date", hideable: true, hide: false, editable: false, headerName: "Effective Date", width: 150, renderCell: (params) => <p>{getFormatedDate(params.row.effective_date)}</p>},
        {field: "tag", hideable: true, hide: false, editable: false, headerName: "TAG", width: 150,
            renderCell: (params) => (
                <div className="tag-cell">
                    <i className="bi bi-tag-fill"></i>
                    {params.value}
                </div>
            )
        },
        {field: "asset_ob", hideable: true, hide: false, editable: false, headerName: "Opening Value", width: 150, renderCell: (params) => <p>{parseFloat(params.row.asset_ob).toFixed(2)}</p>},
        {field: "asset_added_value", hideable: true, hide: false, editable: false, headerName: "Addition", width: 150, renderCell: (params) => <p>{parseFloat(params.row.asset_added_value).toFixed(2)}</p>},
        {field: "asset_deleted_value", hideable: true, hide: false, editable: false, headerName: "Deletion", width: 150, renderCell: (params) => <p>{parseFloat(params.row.asset_deleted_value).toFixed(2)}</p>},
        {field: "asset_cb", hideable: true, hide: false, editable: false, headerName: "Closing Value", width: 150, renderCell: (params) => <p>{parseFloat(params.row.asset_cb).toFixed(2)}</p>},
        {field: "depreciation_ob", hideable: true, hide: false, editable: false, headerName: "Opening Acc Dep", width: 150, renderCell: (params) => <p>{parseFloat(params.row.depreciation_ob).toFixed(2)}</p>},
        {field: "depreciation_added_value", hideable: true, hide: false, editable: false, headerName: "Addition for the Period", width: 250, renderCell: (params) => <p>{parseFloat(params.row.depreciation_added_value).toFixed(2)}</p>},
        {field: "depreciation_deleted_value", hideable: true, hide: false, editable: false, headerName: "Deletion for the Period", width: 250, renderCell: (params) => <p>{parseFloat(params.row.depreciation_deleted_value).toFixed(2)}</p>},
        {field: "depreciation_adjusted_value", hideable: true, hide: false, editable: false, headerName: "Adjustment for the Period", width: 250, renderCell: (params) => <p>{parseFloat(params.row.depreciation_adjusted_value).toFixed(2)}</p>},
        {field: "new_depreciation_cb", hideable: true, hide: false, editable: false, headerName: "Closing Acc Dep", width: 150, renderCell: (params) => <p>{parseFloat(params.row.new_depreciation_cb).toFixed(2)}</p>},
        {field: "wdv_ob", hideable: true, hide: false, editable: false, headerName: "Opening WDV", width: 150, renderCell: (params) => <p>{parseFloat(params.row.wdv_ob).toFixed(2)}</p>},
        {field: "wdv_cb", hideable: true, hide: false, editable: false, headerName: "Closing WDV", width: 150, renderCell: (params) => <p>{parseFloat(params.row.wdv_cb).toFixed(2)}</p>},
        {field: "no_of_day", hideable: true, hide: false, editable: false, headerName: "No. of Days YTD", width: 150, renderCell: (params) => <p>{params.row.no_of_day}</p>},
    ];

    const CustomToolbar = () => (
        <GridToolbarContainer>
            {/* Empty toolbar - export handled separately */}
        </GridToolbarContainer>
    );

    const CustomLoader = () => (
        <GridOverlay>
            <CircularProgress color="primary" size={30}/>
        </GridOverlay>
    );

    /* ─── RENDER ─── */
    return (
        <div className="al-page" id="far-depreciation-page">

            {/* ══ PAGE HEADER ══ */}
            <div className="al-page-header" id="al-page-header">
                <div className="al-page-header-left">
                    <div className="al-page-header-icon">
                        <i className="bi bi-file-earmark-spreadsheet-fill"/>
                    </div>
                    <div className="al-page-header-text">
                        <h5 className="al-page-title">Fixed Asset Register - I-GAAP (AS)</h5>
                        <p className="al-page-subtitle">Comprehensive depreciation register for Indian GAAP accounting standards</p>
                    </div>
                </div>
                {!loading && items.length > 0 && (
                    <div className="al-record-badge" id="al-record-badge">
                        <i className="bi bi-layers-fill"/>
                        <strong>{totalItems.toLocaleString('en-IN')}</strong>&nbsp;Total Records
                    </div>
                )}
            </div>

            {/* ══ DATE FILTER PANEL ══ */}
            <div className="al-filter-card" id="al-filter-panel">
                <div className="al-filter-card-header">
                    <span className="al-filter-card-title">
                        <i className="bi bi-calendar-range-fill"/> Select Date Range
                    </span>
                </div>
                <div className="al-filter-card-body">
                    <div className="al-date-grid" style={{gridTemplateColumns: '1fr 1fr auto auto'}}>
                        <div className="al-filter-group">
                            <FromFieldDate
                                star="*"
                                label="From Date"
                                inputValue={fromperiod}
                                setInputValue={setFromPeriod}
                                setErrorMsg={ErrFromPeriod}
                            />
                        </div>
                        <div className="al-filter-group">
                            <FromFieldDate
                                star="*"
                                label="To Date"
                                inputValue={toperiod}
                                setInputValue={setToPeriod}
                                setErrorMsg={ErrToPeriod}
                            />
                        </div>
                        <div className="al-filter-group" style={{display: 'flex', alignItems: 'flex-end'}}>
                            <button className="al-btn al-btn-primary" onClick={fetchDepreciation}>
                                <i className="bi bi-search"/> Fetch Data
                            </button>
                        </div>
                        <div className="al-filter-group" style={{display: 'flex', alignItems: 'flex-end'}}>
                            <button className="al-btn al-btn-outline" onClick={fetchAssetsCSV} disabled={exporting}>
                                {exporting ? (
                                    <><span className="al-dot"/><span className="al-dot"/><span className="al-dot"/> Exporting…</>
                                ) : (
                                    <><i className="bi bi-file-earmark-arrow-down"/> Export to CSV</>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* ══ DATA GRID CARD ══ */}
            <div className="al-grid-card" id="al-grid-card">
                <div className="al-grid-card-header">
                    <span className="al-grid-card-title">
                        <i className="bi bi-table"/> FAR Depreciation Records
                    </span>
                    {!loading && items.length > 0 && (
                        <span className="al-showing-badge">
                            Showing <strong>{items.length}</strong> of <strong>{totalItems.toLocaleString('en-IN')}</strong>
                        </span>
                    )}
                </div>

                <Box>
                    <DataGrid
                        rows={items}
                        getRowId={(row) => row.id}
                        columns={columns}
                        autoHeight
                        className="al-data-grid"
                        components={{
                            LoadingOverlay: CustomLoader,
                            Toolbar: CustomToolbar,
                            Pagination: () => (
                                <Box className="al-pagination-bar">
                                    <div className="al-page-size-row">
                                        <span className="al-page-size-label">Rows per page</span>
                                        <Select
                                            options={[
                                                {value: 50, label: '50'},
                                                {value: 100, label: '100'},
                                                {value: 200, label: '200'},
                                                {value: 500, label: '500'},
                                            ]}
                                            value={{value: pageSize, label: pageSize.toString()}}
                                            onChange={(selected) => handlePageSizeChange(selected.value)}
                                            classNamePrefix="al-select"
                                            menuPlacement="top"
                                            styles={{container: (base) => ({...base, minWidth: 80})}}
                                        />
                                    </div>
                                    <Pagination
                                        count={totalPages}
                                        page={page}
                                        onChange={handlePageChange}
                                        variant="outlined"
                                        shape="rounded"
                                        size="small"
                                    />
                                </Box>
                            ),
                        }}
                        loading={loading}
                    />
                </Box>
            </div>
        </div>
    )
}

export default FarDepreciation